import { cookieKey } from '@/infrastructure/adapters/constants';
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'dl-cookie-modal',
  setup() {
    const cookieModalOpen = ref(false);
    const modalKey = ref(0);

    const toggle = () => {
      alert('toggle');
    };

    const onModalClick = () => {
      document.dispatchEvent(new CustomEvent('modal-toggle', { detail: { modalId: 'cookie-consent-modal' } }));
    };

    onMounted(() => {
      if (localStorage.getItem(cookieKey) === null) {
        cookieModalOpen.value = true;
        modalKey.value += 1;
      }
    });

    return {
      cookieModalOpen,
      modalKey,
      onModalClick,
      toggle
    };
  }
});
